import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { data } from "../../constants";

import images from "../../constants/images";

import "./Navbar.css";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);


  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <img src={images.sheafify} alt="app logo" />
      </div>
      <ul className="app__navbar-links">
        {data.navLinks.map((link) => {
          return (
            <li key={link.href} className="p__opensans">
              <a
                href={link.href}
              >
                {link.title}
              </a>
            </li>
          );
        })}
      </ul>
      <div className="app__navbar-login">
        <a href="/" className="p__opensans">
          Reserve a Table
        </a>
      </div>
      <div className="app__navbar-smallcreen">
        <GiHamburgerMenu
          className="app__navbar-burger-menu"
          color="#fff"
          fontSize={27}
          onClick={() => setToggleMenu((prev) => !prev)}
        />

        {toggleMenu && (
          <div className="app__navbar-smallscreen_overlay flex__center slide-bottom">
            <MdOutlineRestaurantMenu
              fontSize={27}
              className="overlay__close"
              onClick={() => setToggleMenu((prev) => !prev)}
            />
            <ul className="app__navbar-smallscreen_links">
              {data.navLinks.map((link) => {
                return (
                  <li key={link.href} className="p__opensans">
                    <a
                      href={link.href}
                      onClick={() => setToggleMenu((prev) => !prev)}
                    >
                      {link.title}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
